export const createObservable = <T>() => {
  const listeners: ((value: T) => void)[] = [];

  const subscribe = (listener: (value: T) => void) => {
    listeners.push(listener);

    return () => {
      const index = listeners.indexOf(listener);
      if (index > -1) listeners.splice(index, 1);
    };
  };

  const next = (value: T) => {
    listeners.forEach((listener) => listener(value));
  };

  const complete = () => {
    listeners.length = 0;
  };

  return { subscribe, next, complete };
};
